import { type FC } from "react";
import { Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Dropzone } from "@/shared/components/Dropzone";
import { ImageQuery, UploadImageMutation } from "@/shared/graphql";
import { EMAIL_TEMPLATE_LIMITS, type EditorBlock } from "../model/blocks";

interface ImageBlockFieldProps {
  block: EditorBlock;
  onChange: (patch: Partial<EditorBlock>) => void;
}

/**
 * Форма IMAGE: картинка из медиатеки через общий Dropzone в управляемом
 * режиме (id картинки в блоке, превью Dropzone достаёт сам по ImageQuery,
 * поэтому imageUrl из ответа сервера редактору не нужен), подпись alt и
 * необязательная ссылка по клику.
 */
export const ImageBlockField: FC<ImageBlockFieldProps> = ({
  block,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Dropzone
        label={t("emailTemplates.blocks.image")}
        helperText={t("emailTemplates.blocks.imageHint")}
        value={block.imageId}
        onChange={(imageId) => onChange({ imageId })}
        query={ImageQuery}
        mutation={UploadImageMutation}
        accept="image/*"
        width="100%"
        height={200}
        square
        required
      />
      <TextField
        label={t("emailTemplates.blocks.alt")}
        value={block.alt ?? ""}
        onChange={(event) => onChange({ alt: event.target.value || null })}
        helperText={t("emailTemplates.blocks.altHint")}
        slotProps={{
          htmlInput: { maxLength: EMAIL_TEMPLATE_LIMITS.label },
        }}
        fullWidth
      />
      <TextField
        label={t("emailTemplates.blocks.imageUrl")}
        value={block.url ?? ""}
        onChange={(event) => onChange({ url: event.target.value || null })}
        helperText={t("emailTemplates.blocks.urlHint")}
        placeholder="https://"
        slotProps={{
          htmlInput: { maxLength: EMAIL_TEMPLATE_LIMITS.url },
        }}
        fullWidth
      />
    </Stack>
  );
};
